/**
 * Settings for the USB QR scanner at the front desk.
 *
 * Default: USB keyboard-wedge. The gun types into whichever app is focused (Chrome, Cursor, etc.).
 * To stop that, program the gun to USB Virtual COM and click "Link USB gun" on Walk-Ins. Chrome then
 * reads the gun directly, even when another app has the keyboard.
 * Override any value in .env.localapi / .env.prodapi with a VITE_SCANNER_* variable.
 */

function numberFromEnv(value: string | undefined, fallback: number): number {
  if (value === undefined || value === '') return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
}

const env = import.meta.env;

export const scannerConfig = {
  /** Every CWY check-in QR starts with this. Anything else typed on the page is ignored. */
  prefix: (env.VITE_SCANNER_PREFIX as string | undefined) || 'CWY1.',
  /** Shortest text that can be a code. */
  minChars: numberFromEnv(env.VITE_SCANNER_MIN_CHARS, 15),
  /** Keystrokes slower than this (ms, on average) look like a person typing, not the gun. */
  maxIntervalMs: numberFromEnv(env.VITE_SCANNER_MAX_INTERVAL_MS, 50),
  /** Guns without an Enter suffix: fire this long after a full code has been typed. 0 means fire at once. */
  idleEmitMs: numberFromEnv(env.VITE_SCANNER_IDLE_EMIT_MS, 0),
  /** A code that stops arriving before it is complete is reported as a partial read after this long. */
  partialReadMs: numberFromEnv(env.VITE_SCANNER_PARTIAL_READ_MS, 700),
  /** Software beep. Off because the gun already beeps by itself. */
  playBeep: env.VITE_SCANNER_PLAY_BEEP === 'true',
} as const;
